export default {
  namespaced: true,
  state: {
    distributorsList: [],
    channelsList: [],
  },
  actions: {
    GetDistributorsList({ commit, rootGetters, dispatch }) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/distributors/search')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'distributorsList', value: response.data.items });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetChannelsList({ commit, rootGetters, dispatch }) {
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('sales/api/channels/list')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'channelsList', value: response.data.items });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
